// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__iKJpt","twocols":"Faq_twocols__OEoAM","righticon":"Faq_righticon__zlxqi","faqleft":"Faq_faqleft__GUVqE","leftinfo":"Faq_leftinfo__c+KT1"};